import React from 'react';
import { PlusIcon, Trash2 } from 'lucide-react';

interface SelectedItem {
  id: string | number;
  type: 'folder' | 'file';
  name: string;
}

interface BlogTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onNewFolder: () => void;
  onNewFile: () => void;
  selectedItems?: SelectedItem[];
  onBulkDelete?: () => void;
}

const BlogTabs: React.FC<BlogTabsProps> = ({
  activeTab,
  setActiveTab,
  onNewFolder,
  onNewFile,
  selectedItems = [],
  onBulkDelete,
}) => {
  return (
    <div className="flex justify-between mb-6">
      <div className="flex  bg-secondary overflow-hidden">
        <button
          onClick={() => setActiveTab('myfiles')}
          className={`px-6 py-2 ${
            activeTab === 'myfiles' ? 'bg-primary text-white' : 'text-primary'
          }`}
        >
          My Files
        </button>
        {/* <button
          onClick={() => setActiveTab('published')}
          className={`px-6 py-2 ${
            activeTab === 'published'
              ? 'bg-[#846CEC] text-white'
              : 'text-[#846CEC]'
          }`}
        >
          Published and Scheduled
        </button> */}
        <button
          onClick={() => setActiveTab('shared')}
          className={`px-6 py-2 ${
            activeTab === 'shared'
              ? 'bg-[#846CEC] text-white'
              : 'text-[#846CEC]'
          }`}
        >
          Shared with me
        </button>
      </div>
      <div className="flex gap-2">
        {selectedItems.length > 0 && (
          <button
            onClick={onBulkDelete}
            className="flex items-center gap-1 px-4 py-2 text-primary  rounded-md"
            title={`Delete ${selectedItems.length} selected item(s)`}
          >
            <Trash2 size={20} />
          </button>
        )}
        {activeTab === 'myfiles' && (
          <button
            onClick={onNewFolder}
            className="flex items-center gap-1 px-4 py-2 text-[#846CEC] underline rounded-md"
          >
            <PlusIcon size={16} />
            <span>New Folder</span>
          </button>
        )}
        {activeTab === 'myfiles' && (
          <button
            onClick={onNewFile}
            className="flex items-center gap-1 px-4 py-2 text-[#846CEC] underline rounded-md"
          >
            <PlusIcon size={16} />
            <span>New File</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default BlogTabs;
